import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { MuButtonSkin } from '../../../models/interface/muButtonSkin.enum';
import { Actions } from '../../../types/actions.type';
import { Flags } from '../../../types/flags.type';

@Component({
  selector: 'app-mu-button-extra',
  templateUrl: './mu-button-extra.component.html',
  styleUrls: ['./mu-button-extra.component.sass'],
})
export class MuButtonExtraComponent<ActionType, FlagType> implements OnInit {
  @Input() icon: string;
  @Input() colSize: number;
  @Input() colMdSize: number;
  @Input() colLgSize: number;
  @Input() label: string;
  @Input() actionList: Actions<ActionType, any>;
  @Input() action: ActionType;
  @Input() flagList: Flags<FlagType>;
  @Input() activeFlag: FlagType;
  @Input() activeLabel: string;
  @Input() hasPermission: boolean;
  @Input() buttonStyle: string;
  @Input() redirect: string;
  @Input() skin: MuButtonSkin;
  @HostBinding('class') baseClass: string;
  flagToContinueAdd = true;

  constructor(private router: Router) {
    /** */
  }

  ngOnInit(): void {
    this.baseClass = 'p-field p-col-' + (this.colSize || 12) + '';
    this.baseClass += ' p-md-' + (this.colMdSize || 12) + '';
    this.baseClass += ' p-lg-' + (this.colLgSize || 12) + ' mu-action-add mu-button-extra';
    this.baseClass += !this.hasPermission && this.hasPermission !== undefined ? ' mu-field-disabled' : '';
  }

  /**
   * emit actions to parent component
   */
  emitAction(): void {
    if (this.redirect && this.hasPermission) {
      this.router.navigate([this.redirect]);
      return environment.guardClause;
    }
    if (!this.hasPermission || !this.flagToContinueAdd || !this.actionList) {
      return environment.guardClause;
    }
    this.flagToContinueAdd = false;
    setTimeout(() => (this.flagToContinueAdd = true), 1000);
    this.actionList.emit(this.action, null);
  }
}
